import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  FormControl,
  Button,
  IconButton,
  InputLabel,
  Select,
  MenuItem,
  Typography
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
//import AutoFixHighOutlined from '@mui/icons-material/AutoFixHighOutlined';
import { refineRisk, updateRiskName } from './redux/actions/riskActions';
//import IconWithProgress from './IconWithProgress';



function RefineRiskModal({ open, onClose, modelId, sectionName, existingRisk }) {
  const dispatch = useDispatch();
  const [riskText, setRiskText] = useState('');
  const [instructionType, setInstructionType] = useState('specific');
  const [customInstruction, setCustomInstruction] = useState('');
  const refinedRiskDraft = useSelector(state => state.risks.refinedRiskDraft);
  //const isLoading = useSelector(state => state.risks.models[modelId]?.loading);
  
  useEffect(() => {
    if (existingRisk) {
      setRiskText(existingRisk.riskName);
    }
  }, [existingRisk]);

  // const handleRefineClick = () => {
  //   let userInstruction = '';
  //   if (instructionType === 'custom') {
  //     userInstruction = customInstruction;
  //   } else if (instructionType === 'specific') {
  //     userInstruction = 'Make the risk more specific and focused';
  //   } else if (instructionType === 'technical') {
  //     userInstruction = 'Make the risk more technical in wording';
  //   } else if (instructionType === 'formal') {
  //     userInstruction = 'Make the risk more formal in tone';
  //   }

  //   dispatch(refineRisk({
  //     modelId,
  //     sectionName,
  //     category: existingRisk.category,
  //     originalName: existingRisk.riskName,
  //     originalRiskText: riskText,
  //     userInstruction,
  //     context: {}
  //   }));
  // };
  const handleRefineClick = () => {
    let userInstruction = '';
    if (instructionType === 'custom')      userInstruction = customInstruction;
    else if (instructionType === 'specific')   userInstruction = 'Make the risk more specific and focused';
    else if (instructionType === 'technical')   userInstruction = 'Make the risk more technical in wording';
    else if (instructionType === 'formal')      userInstruction = 'Make the risk more formal in tone';

    const payload = {
      modelId,
      sectionName,
      category: existingRisk.category,
      originalName: existingRisk.riskName,
      originalRiskText: riskText,
      userInstruction,
      context: {}
    };

    console.log('[RefineRiskModal] dispatching refineRisk with:', payload);
    dispatch(refineRisk(payload));
  };
  const handleApply = () => {
    if (refinedRiskDraft?.risk) {
      dispatch(
        updateRiskName(
          modelId,
          sectionName,
          existingRisk.category,
          existingRisk.riskName,
          refinedRiskDraft.risk
        )
      );
    }
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose}>
      <DialogTitle sx={{ m: 0, p: 2 }}>
        Refine Risk
        <IconButton
          aria-label="close"
          onClick={onClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

     <DialogContent sx={{ p: 2, pt: 0 }}>
        <TextField
          label="Risk Text"
          value={riskText}
          onChange={e => setRiskText(e.target.value)}
          fullWidth
          multiline
          sx={{ mb: 2 }}
        />

        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="instruction-type-label">Make more</InputLabel>
          <Select
            labelId="instruction-type-label"
            id="instruction-type"
            value={instructionType}
            label="Make more"
            onChange={e => setInstructionType(e.target.value)}
          >
            <MenuItem value="specific">specific and focused</MenuItem>
            <MenuItem value="technical">technical in wording</MenuItem>
            <MenuItem value="formal">formal in tone</MenuItem>
            <MenuItem value="custom">custom</MenuItem>
          </Select>
        </FormControl>

        {instructionType === 'custom' && (
          <TextField
            label="Custom Instruction"
            value={customInstruction}
            onChange={e => setCustomInstruction(e.target.value)}
            fullWidth
            multiline
            sx={{ mb: 2 }}
          />
        )}

            <Button
              variant="outlined"
              onClick={handleRefineClick}
              //disabled={isLoading}
              // startIcon={
              //   isLoading ? <IconWithProgress isLoading /> : <AutoFixHighOutlined />
              // }
              sx={{ mb: 2, minWidth: 110 }}
            >
              Refine
            </Button>

        {refinedRiskDraft?.risk && (
          <>
            <Typography sx={{ mt: 2, fontWeight: 'bold' }}>Refined Risk:</Typography>
            <Typography>{refinedRiskDraft.risk}</Typography>

            <Typography sx={{ mt: 1, fontStyle: 'italic' }}>Rationale:</Typography>
            <Typography>{refinedRiskDraft.rationale}</Typography>

            <Button variant="contained" onClick={handleApply} sx={{ mt: 2 }}>
              Accept
            </Button>
          </>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default RefineRiskModal;

